/**
 * generate unique simple keys/ids/numbers/strings
 * @param {string} pre
 * @return {`${string}_${string}`}
 */
const generateKey = pre => `${pre}_${Math.random().toString(36).substr(2, 9)}`;

export default generateKey;
